import React, { Component } from 'react';
import { Container } from 'reactstrap';
import NavMenu  from './NavMenu';
import { MyGlobal } from './GlobalContext';

export class Layout extends Component {
  static displayName = Layout.name;
    
    render() {
        let menu = <NavMenu />;
        if (!MyGlobal.isAuthed())
            menu = "";

    return (
      <div>
            {menu}
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
